import React from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { BackButtonContainer, ButtonText } from "../../style/sidebar.styles";

export default function BackButton({ text = "Go Back", path = "/" }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(path);
  };

  return (
    <BackButtonContainer onClick={handleClick}>
      <ArrowLeft size={16} />
      <ButtonText>{text}</ButtonText>
    </BackButtonContainer>
  );
}
